import React from 'react'

const Billing = ({ getAngel }) => {
    return (
        <div className='angel-admin-billing'>
            <div className='angel-billing-section'>
                <div className="billing-list">
                    {
                        getAngel?.billingDetail?.map((item, index) => {
                            return <div className='billing-list-card' key={index}>
                                <div className='card-description'>
                                    <div className={`list-name ${item?.status === 'Success' ? 'success' : item?.status === 'Failed' ? 'failed' : 'refund'}`}>Payment {item?.status} {item?.amount}</div>
                                </div>
                                <div className='card-time'>
                                    {item?.duration}
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Billing